import React from 'react';
import AboutPage from '../components/AboutPage';

const About = () => {
  return <AboutPage lang="en" title="About the course | COMP 227" />;
};

export default About;
